import { render } from "./formsummery.vue?vue&type=template&id=61cebd84&scoped=true"
import script from "./formsummery.js?vue&type=script&lang=js"
export * from "./formsummery.js?vue&type=script&lang=js"

import "./formsummery.vue?vue&type=style&index=0&id=61cebd84&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61cebd84"]])

export default __exports__